import { useEffect, useState } from "react";
import API from "../../services";
import Loader from "../../components/Loader";
import ErrorMessage from "../../components/ErrorMessage";
import { Colors } from "../../utils/colors";
import ContactListing from "./ContactListing";
import type { IContactsCategoriesItem } from "../../services/types";
import "./index.css";

type Tab = {
  key: string; // category id as string
  title: string;
};

export default function ContactsScreen() {
  const [index, setIndex] = useState(0);
  const [isLoading, setLoading] = useState(true);
  const [tabs, setTabs] = useState<Tab[]>([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const data =
          (await API.getContactsCategories()) as IContactsCategoriesItem[];
        if (!Array.isArray(data)) throw new Error("Bad categories payload");

        const mapped: Tab[] = data?.map((item) => ({
          key: String(item.contactCategoryGuid),
          title: item.contactCategoryName,
        }));

        setTabs(mapped);
        setError(false);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (isLoading) return <Loader />;
  if (error) return <ErrorMessage />;
  if (!tabs.length) return <ErrorMessage />;

  const active = tabs[Math.min(index, tabs.length - 1)];

  console.log(tabs,'tabs in row');
  
  

  return (
    <div className="contacts-container">
      {/* Tab header */}
      <div className="contacts-tab-bar">
        {tabs?.map((t, i) => {
          const activeTab = i === index;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setIndex(i)}
              className="contacts-tab-button"
              style={{
                color: activeTab ? Colors.White : "rgba(255,255,255,0.30)",
                borderBottomColor: activeTab ? Colors.White : "transparent",
              }}
            >
              {t.title}
            </button>
          );
        })}
      </div>

      {/* Active tab content */}
      <div className="contacts-scene">
        <ContactListing title={active.title} contactCategoryGuid={active.key} />
      </div>
    </div>
  );
}
